export default {
  SIGN_FAILED: 'Failed to sign message',
  INVALID_LENGTH: 'Invalid signature length',
  FAILED_TO_VERIFY: 'Failed to verify signature'
};
